import GameParameterInterface from '@/models/game/parameters/interface'

interface ScratchLotteryParameter {
  prize: ScratchGamePrize
}

interface ScratchGamePrize {
  prizeImage: string,
  guideUrl: string,
}

export default class ScratchParameter implements GameParameterInterface {
  constructor(private parameter: ScratchLotteryParameter) { }

  createSetOption(): ScratchLotteryParameter {
    return {
      prize: this.parameter.prize,
    }
  }

  get guideUrl(): string {
    return this.parameter.prize.guideUrl
  }
}
